export const MagnifyingIcon = (
  <svg
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="8.8055"
      cy="8.80547"
      r="7.49047"
      stroke="#BDBDBD"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14.0153 14.4042L16.9519 17.3333"
      stroke="#BDBDBD"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const TrashBin = (
  <svg
    width="19"
    height="20"
    viewBox="0 0 19 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.3248 7.46826C16.3248 7.46826 15.7818 14.2033 15.4668 17.0403C15.3168 18.3953 14.4798 19.1893 13.1088 19.2143C10.4998 19.2613 7.88779 19.2643 5.27979 19.2093C3.96079 19.1823 3.13779 18.3783 2.99079 17.0473C2.67379 14.1853 2.13379 7.46826 2.13379 7.46826"
      stroke="#9E9E9E"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M17.708 4.23975H0.75"
      stroke="#9E9E9E"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14.4406 4.23973C13.6556 4.23973 12.9796 3.68473 12.8256 2.91573L12.5826 1.69973C12.4326 1.13873 11.9246 0.750732 11.3456 0.750732H7.11258C6.53358 0.750732 6.02558 1.13873 5.87558 1.69973L5.63258 2.91573C5.47858 3.68473 4.80258 4.23973 4.01758 4.23973"
      stroke="#9E9E9E"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const Like = (
  <svg
    width="22"
    height="20"
    viewBox="0 0 22 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.87187 9.59832C0.798865 6.24832 2.05287 2.41932 5.56987 1.28632C7.41987 0.689322 9.46187 1.04132 10.9999 2.19832C12.4549 1.07332 14.5719 0.693322 16.4199 1.28632C19.9369 2.41932 21.1989 6.24832 20.1269 9.59832C18.4569 14.9083 10.9999 18.9983 10.9999 18.9983C10.9999 18.9983 3.59787 14.9703 1.87187 9.59832Z"
      stroke="#9E9E9E"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15 4.69995C16.07 5.04595 16.826 6.00095 16.917 7.12195"
      stroke="#9E9E9E"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const Copy = (
  <svg
    width="20"
    height="28"
    viewBox="0 0 58 71"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="11.5" y="1.5" width="45" height="57" rx="3.5" fill="#D9D9D9" />
    <rect
      x="11.5"
      y="1.5"
      width="45"
      height="57"
      rx="3.5"
      stroke="black"
      stroke-width="3"
    />
    <rect x="1.5" y="12.5" width="45" height="57" rx="3.5" fill="#D9D9D9" />
    <rect
      x="1.5"
      y="12.5"
      width="45"
      height="57"
      rx="3.5"
      stroke="black"
      stroke-width="3"
    />
  </svg>
);

export const Share = (
  <svg
    width="20"
    height="26"
    viewBox="0 0 64 72"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="52.5"
      cy="60.5"
      r="10"
      fill="#D9D9D9"
      stroke="black"
      stroke-width="3"
    />
    <circle
      cx="52.5"
      cy="11.5"
      r="10"
      fill="#D9D9D9"
      stroke="black"
      stroke-width="3"
    />
    <circle
      cx="11.5"
      cy="36.5"
      r="10"
      fill="#D9D9D9"
      stroke="black"
      stroke-width="3"
    />
    <line
      x1="20.1947"
      y1="29.7345"
      x2="42.1947"
      y2="15.7345"
      stroke="black"
      stroke-width="3"
    />
    <line
      x1="20.8053"
      y1="41.7345"
      x2="42.8056"
      y2="55.734"
      stroke="black"
      stroke-width="3"
    />
  </svg>
);

export const Copied = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 35 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="17.5" cy="17.5" r="17" fill="white" stroke="black" />
    <line x1="8.035" y1="19.6359" x2="14.5735" y2="25.7897" stroke="black" />
    <line x1="13.8772" y1="25.8003" x2="29.2618" y2="10.4157" stroke="black" />
  </svg>
);

export const ExitX = (
  <svg
    width="30"
    height="30"
    viewBox="0 0 95 95"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="47.5"
      cy="47.5"
      r="46"
      fill="white"
      stroke="black"
      stroke-width="3"
    />
    <line
      x1="67.0552"
      y1="29.0673"
      x2="30.0552"
      y2="65.6898"
      stroke="black"
      stroke-width="3"
    />
    <line
      x1="64.9435"
      y1="65.6909"
      x2="27.9459"
      y2="29.066"
      stroke="black"
      stroke-width="3"
    />
  </svg>
);
